export const environment = {
    production: false,
    configFile: '/assets/Configurations/Configurations.Development.json'
  };